import {
  FileText, Truck, Calendar, DollarSign, Building2 
} from 'lucide-react';
import { cn } from '@/lib/classnames';
import type { PurchaseOrder } from '../../types';
import {
  PO_STATUS_LABELS, PO_STATUS_COLORS 
} from '../../types';

interface PurchaseOrderCardProps {
  readonly po: PurchaseOrder;
  readonly onClick?: () => void;
}

export function PurchaseOrderCard({
  po, onClick 
}: PurchaseOrderCardProps) {
  return (
    <button type="button" onClick={onClick} className="w-full rounded-lg border bg-white p-4 text-left transition-shadow hover:shadow-md">
      <div className="flex items-start justify-between">
        <div className="flex items-center gap-3">
          <div className="rounded-md bg-primary/10 p-2"><FileText className="h-5 w-5 text-primary" /></div>
          <div>
            <h3 className="font-medium text-gray-900">{po.poNumber}</h3>
            <p className="flex items-center gap-1 text-sm text-gray-500"><Building2 className="h-3 w-3" /> {po.supplierName}</p>
          </div>
        </div>
        <span className={cn('rounded-full px-2 py-1 text-xs font-medium', PO_STATUS_COLORS[po.status])}>{PO_STATUS_LABELS[po.status]}</span>
      </div>

      <div className="mt-3 flex flex-wrap items-center gap-4 text-sm text-gray-500">
        <span className="flex items-center gap-1"><Truck className="h-4 w-4" /> {po.deliverySiteName}</span>
        <span className="flex items-center gap-1"><Calendar className="h-4 w-4" /> {new Date(po.expectedDeliveryDate).toLocaleDateString()}</span>
        <span className="flex items-center gap-1 font-medium text-gray-900"><DollarSign className="h-4 w-4" /> {po.total.toLocaleString()} {po.currency}</span>
      </div>

      <div className="mt-3 space-y-1">
        {po.lines.slice(0, 3).map((line) => (
          <div key={line.lineId} className="flex items-center justify-between text-sm">
            <span className="text-gray-700">{line.itemName}</span>
            <span className="text-gray-500">{line.quantity} {line.unit} @ ${line.unitPrice}</span>
          </div>
        ))}
        {po.lines.length > 3 && <p className="text-xs text-gray-400">+{po.lines.length - 3} more items</p>}
      </div>

      {po.notes && <p className="mt-2 text-sm text-amber-600">{po.notes}</p>}
    </button>
  );
}
